import React from 'react';
import { Zap, RefreshCw } from 'lucide-react';

const AIImproveButton = ({
  fieldType,
  currentText,
  experienceIndex,
  isVisible,
  style,
  onImprove,
  isImproving,
  disabled = false
}) => {
  return (
    <button
      className={`ai-improve-button ${isVisible ? 'visible' : 'hidden'}`}
      onClick={onImprove}
      disabled={disabled || isImproving || !currentText?.trim()}
      title="Improve with AI"
      style={style}
    >
      {isImproving ? (
        <RefreshCw size={14} className="spinning" />
      ) : (
        <Zap size={14} />
      )}
    </button>
  );
};

export default AIImproveButton;
